export { default } from "./CreateMemberPopup";



// WEBPACK FOOTER //
// ./src/routes/Admin/ManageUserPage/CreateMemberPopup/index.ts